export default {
      id: "logo_dourdan_maville-usage",
      viewBox: "0 0 140 100",
      url: "../dist/images/" + "sprite.svg#logo_dourdan_maville-usage",
      toString: function () {
        return this.url;
      }
    }